module.exports = __webpack_public_path__ + "de1d9204667e228b61ae2e433cbfb499.svg";